module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("确认发票信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '发票抬头不能为空'
      }],
      "label": "发票抬头",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入发票抬头"
    },
    model: {
      value: (_vm.row.fapiao_taitou),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_taitou", $$v)
      },
      expression: "row.fapiao_taitou"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '税号不能为空'
      }],
      "label": "税号",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入税号"
    },
    model: {
      value: (_vm.row.fapiao_shuihao),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_shuihao", $$v)
      },
      expression: "row.fapiao_shuihao"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("如果您所在的单位没有纳税人识别号请填写“无”")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "地址",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "（非必填）发票购买方地址"
    },
    model: {
      value: (_vm.row.fapiao_address),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_address", $$v)
      },
      expression: "row.fapiao_address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "电话",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "（非必填）发票购买方电话"
    },
    model: {
      value: (_vm.row.fapiao_tel),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_tel", $$v)
      },
      expression: "row.fapiao_tel"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "开户行及账号",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "（非必填）发票购买方开户行及账号"
    },
    model: {
      value: (_vm.row.fapiao_account),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_account", $$v)
      },
      expression: "row.fapiao_account"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "发票备注",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入发票备注"
    },
    model: {
      value: (_vm.row.fapiao_beizhu),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_beizhu", $$v)
      },
      expression: "row.fapiao_beizhu"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.email,
        message: '请输入正确的邮箱'
      }],
      "error-message-align": "right",
      "label": "接收邮箱",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入接收邮箱"
    },
    model: {
      value: (_vm.row.fapiao_email),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_email", $$v)
      },
      expression: "row.fapiao_email"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "接收手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入接收手机"
    },
    model: {
      value: (_vm.row.fapiao_phone),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_phone", $$v)
      },
      expression: "row.fapiao_phone"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.2rem"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "10px"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "保存中...",
      "native-type": "submit"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确认发票信息")])], 1)], 1), _vm._v(" "), _c('van-divider', [_vm._v("费用信息")]), _vm._v(" "), _c('van-cell-group', [_vm._l((_vm.row.list), function(item, index) {
    return _c('van-cell', {
      key: index,
      attrs: {
        "input-align": "right",
        "title": item.service_name,
        "value": '¥' + item.price + ' x ' + item.count
      }
    })
  }), _vm._v(" "), _vm._l((_vm.row.list), function(item, index) {
    return (item.memberprice > 0) ? _c('van-cell', {
      key: index,
      attrs: {
        "input-align": "right",
        "title": "人员费用",
        "value": '¥' + item.memberprice + ' x ' + item.count
      }
    }) : _vm._e()
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "费用总计",
      "value": _vm.row.order.total
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.payActions
    },
    on: {
      "select": _vm.onPaySelect
    },
    model: {
      value: (_vm.payShow),
      callback: function($$v) {
        _vm.payShow = $$v
      },
      expression: "payShow"
    }
  }), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "请扫码加入报名群",
      "show-cancel-button": "",
      "showConfirmButton": false
    },
    model: {
      value: (_vm.payOffShow),
      callback: function($$v) {
        _vm.payOffShow = $$v
      },
      expression: "payOffShow"
    }
  }, [_vm._l((_vm.row.wechat_erweiimg), function(wechat_erweiimg_url, wechat_erweiimg_key) {
    return _c('p', {
      key: wechat_erweiimg_key,
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('img', {
      staticStyle: {
        "width": "70%"
      },
      attrs: {
        "src": wechat_erweiimg_url
      }
    })])
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin": "10px 0"
    }
  }, [_c('van-button', {
    attrs: {
      "size": "normal",
      "type": "default",
      "round": ""
    },
    on: {
      "click": _vm.downloadpic
    }
  }, [_vm._v("下载图片")]), _vm._v(" "), _c('van-button', {
    attrs: {
      "size": "normal",
      "round": "",
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
    },
    on: {
      "click": _vm.onApplySuccess
    }
  }, [_vm._v("完成报名")])], 1)], 2), _vm._v(" "), _c('PayDialog', {
    attrs: {
      "show": _vm.payDialogShow,
      "scene": "huiyi_baoming",
      "ids": _vm.orderIds
    },
    on: {
      "onPayError": _vm.onPayError,
      "onPaySuccess": _vm.onPaySuccess,
      "onPayClose": _vm.onPayClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1700fc72","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormStepC5.vue
// module id = 2231
// module chunks = 0